import { defineStore, acceptHMRUpdate } from 'pinia';
import { ref } from 'vue';
import { subscribe_with_user } from '../mqtt';
export const useUserStore = defineStore('user', () => {
    //用户信息
    const userInfo = ref(uni.getStorageSync('userInfo') || {});
    const mqttInfo = ref(uni.getStorageSync('mqttInfo') || {});
    //设置用户信息
    const setUserInfo = (user) => {
        userInfo.value = user;
        if (user?.id) {
            subscribe_with_user();
        }
        uni.setStorageSync('userInfo', user);
    };
    //设置用户信息
    const setMqttInfo = (mqttValue = {}) => {
        mqttInfo.value = { ...mqttInfo.value, ...mqttValue };
        uni.setStorageSync('mqttInfo', mqttInfo.value);
    };

    return {
        userInfo,
        mqttInfo,
        setUserInfo,
        setMqttInfo
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot));
}
